module.exports = __webpack_public_path__ + "media/images/profile-d63bb3d27be2a93add3d62d6db4afdcd.svg";